import { z } from "zod";

export const ProductVariantSchema = z.object({
  id: z.number().or(z.string()),
  product_id: z.number().or(z.string()),
  title: z.string(),
  price: z.string(),
  sku: z.string().nullable().optional(),
  position: z.number().optional(),
  inventory_policy: z.string().optional(),
  compare_at_price: z.string().nullable().optional(),
  fulfillment_service: z.string().optional(),
  inventory_management: z.string().nullable().optional(),
  option1: z.string().nullable().optional(),
  option2: z.string().nullable().optional(),
  option3: z.string().nullable().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
  taxable: z.boolean().optional(),
  barcode: z.string().nullable().optional(),
  grams: z.number().optional(),
  image_id: z.number().or(z.string()).nullable().optional(),
  weight: z.number().optional(),
  weight_unit: z.string().optional(),
  inventory_item_id: z.number().or(z.string()).optional(),
  inventory_quantity: z.number().optional(),
  old_inventory_quantity: z.number().optional(),
  requires_shipping: z.boolean().optional(),
  admin_graphql_api_id: z.string().optional(),
});

export const ProductImageSchema = z.object({
  id: z.number().or(z.string()),
  product_id: z.number().or(z.string()),
  position: z.number(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
  alt: z.string().nullable().optional(),
  width: z.number().optional(),
  height: z.number().optional(),
  src: z.string(),
  variant_ids: z.array(z.number().or(z.string())).optional(),
  admin_graphql_api_id: z.string().optional(),
});

export const ProductPayloadSchema = z.object({
  id: z.number().or(z.string()),
  title: z.string(),
  body_html: z.string().nullable().optional(),
  vendor: z.string().optional(),
  product_type: z.string().optional(),
  created_at: z.string().optional(),
  handle: z.string().optional(),
  updated_at: z.string().optional(),
  published_at: z.string().nullable().optional(),
  template_suffix: z.string().nullable().optional(),
  status: z.string().optional(),
  published_scope: z.string().optional(),
  tags: z.string().optional(),
  admin_graphql_api_id: z.string().optional(),
  variants: z.array(ProductVariantSchema).default([]),
  options: z.array(z.any()).optional(),
  images: z.array(ProductImageSchema).default([]),
  image: ProductImageSchema.nullable().optional(),
});

export type ProductPayload = z.infer<typeof ProductPayloadSchema>;

import { BaseEventSchema } from "./pubsub.schema";

export const ProductEventSchema = BaseEventSchema.extend({
  event_type: z.enum(["products/create", "products/update", "products/delete"]),
  payload: ProductPayloadSchema,
});

export type ProductEvent = z.infer<typeof ProductEventSchema>;
